import { render, staticRenderFns } from "./OrderGoodsList.vue?vue&type=template&id=78c0b43a&"
import script from "./OrderGoodsList.vue?vue&type=script&lang=js&"
export * from "./OrderGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports